const el = '[data-content=DeleteGlobalProfileOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DeleteGlobalProfileOverlayDOM)=>{

            const userProfileId = DeleteGlobalProfileOverlayDOM.dataset.userProfileId
            const privacyPolicy = DeleteGlobalProfileOverlayDOM.dataset.privacyPolicy

            Store.commit('main/set_page_overlay_content_data', { userProfileId, privacyPolicy })
        })
    }
}